import {noop} from '@benchling/js-utils';

import {makeReactContext} from 'lib/makeReactContext';
import {InlineBannerProps} from 'ui-library/banners/InlineBanner';

export interface CreateComplexPolymerModalContextPayload {
  setBannerProps: (props: InlineBannerProps | null) => void;
}

const getDefaultContext = (): CreateComplexPolymerModalContextPayload => ({
  setBannerProps: noop,
});

export const CreateComplexPolymerModalContext = makeReactContext<CreateComplexPolymerModalContextPayload>(
  getDefaultContext,
  'CreateComplexPolymerModalContext'
);

/**
 * A context for sharing information from the top-level create complex polymer modal.
 */
export function useCreateComplexPolymerModalContext(): CreateComplexPolymerModalContextPayload {
  return CreateComplexPolymerModalContext.useContext();
}
